export const DD_CHECKOUT_ERROR_METRIC_NAME = 'frontend.checkout.error.count';
